export enum BankAccountErrorCode {
    BankAccountIbanInvalid = 'BANK_ACCOUNT_IBAN_INVALID',
    BankAccountBicInvalid = 'BANK_ACCOUNT_BIC_INVALID',
}

export const BankAccountErrorCodeMessageId: Record<BankAccountErrorCode, string> = {
    [BankAccountErrorCode.BankAccountIbanInvalid]: 'app.error.iban',
    [BankAccountErrorCode.BankAccountBicInvalid]: 'app.error.bic',
};
